import { render, staticRenderFns } from "./bomChangeDialog.vue?vue&type=template&id=1464c206&scoped=true"
import script from "./bomChangeDialog.vue?vue&type=script&lang=js"
export * from "./bomChangeDialog.vue?vue&type=script&lang=js"
import style0 from "./bomChangeDialog.vue?vue&type=style&index=0&id=1464c206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1464c206",
  null
  
)

export default component.exports